import { useTranslation } from "react-i18next";
import { Formatter } from "../../../../../../services/formatter/formatter.service";
import UiButton from "../../../../../../components/button/Button";

const NotesHistoryPanelEdit = (props: {
	lastEditionDate?: string;
	/** Author of the latest version (KAN-2611). */
	lastEditedBy?: string;
	onClickEdit: () => void;
}) => {
	const { t } = useTranslation("common");

	const date = props.lastEditionDate
		? Formatter.dateISOToString(new Date(props.lastEditionDate).toISOString(), {
				day: "2-digit",
				month: "2-digit",
				year: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
			})
		: undefined;

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-end",
				alignItems: "center",
			}}
		>
			<div>
				{date &&
					(props.lastEditedBy
						? t("PARTICIPANT.DASHBOARD.NOTES.EDITED_BY", {
								name: props.lastEditedBy,
								date,
							})
						: t("PARTICIPANT.DASHBOARD.NOTES.EDITED") + " " + date)}
			</div>

			<UiButton
				className="p-button-text neutral ml-2"
				icon="pi pi-pencil"
				onClick={props.onClickEdit}
			/>
		</div>
	);
};

export default NotesHistoryPanelEdit;
